import { getAuth, setFirebaseConfig } from './firebase'
import { useEffect, useMemo } from 'react'
import configuration from '@dtx-company/true-common/src/constants/config'
import type { User } from 'firebase/auth'

interface FirebaseObserver {
  authStateChanged?(user: User | null): void
}

let observers: FirebaseObserver[] = []

function subscribe(observer: FirebaseObserver): void {
  observers.push(observer)
}

function unsubscribe(observer: FirebaseObserver): void {
  observers = observers.filter(element => element !== observer)
}

export function notifyAuthStateChanged(user: User | null): void {
  observers.forEach(observer => observer.authStateChanged?.(user))
}

export function useListenForFirebaseAuthChanges(
  callback: (user: User | null) => Promise<void>
): void {
  useEffect(() => {
    setFirebaseConfig(configuration.firebase)
    getAuth()
  }, [])

  const observer: FirebaseObserver = useMemo(
    () => ({
      authStateChanged: callback
    }),
    [callback]
  )

  useEffect(() => {
    subscribe(observer)
    return () => unsubscribe(observer)
  }, [observer])
}
